import cn from 'classnames';
import { ComponentProps, useEffect, useRef } from 'react';
import { TextField } from '@consta/uikit/TextField';

import styles from './index.module.sass';

export function UiTextField(props: IUiTextFieldProps) {
  const { className, required, ...rest } = props;
  const rootClass = cn(styles.root, className);

  const ref = useRef<HTMLElement>(null);
  useEffect(() => {
    if (ref.current) {
      const input = ref.current.querySelector('input');

      if (required) input?.setAttribute('required', '');
      else input?.removeAttribute('required');
    }
  }, [ref.current, required]);

  return <TextField className={rootClass} required={required} ref={ref} {...rest} />;
}

export interface IUiTextFieldProps extends ComponentProps<typeof TextField> {}
